import { render, staticRenderFns } from "./_ErrorElement.vue?vue&type=template&id=2c0d2437&scoped=true&"
import script from "./_ErrorElement.vue?vue&type=script&lang=js&"
export * from "./_ErrorElement.vue?vue&type=script&lang=js&"
import style0 from "./_ErrorElement.vue?vue&type=style&index=0&id=2c0d2437&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0d2437",
  null
  
)

export default component.exports